import React from 'react'
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ShopCheckoutSideBarResponse } from 'src/Libs/shop/models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import ConfirmCheckoutSingleProduct from './ConfirmCheckoutSingleProduct'
import { useQuantityTypeChangeModal } from '../../hooks/use-shop-quantity-type-change-modal'

interface ConfirmCheckoutProductsProps {
  isDataLoading: boolean
  isCartUpdating: boolean
  products: ShopCheckoutSideBarResponse | null
  onUpdateProduct: (productId: string, quantity: number) => void
  onDeleteProduct: (productId: string) => void
  handleCartResponse: (cartData: ShopCheckoutSideBarResponse | null) => void
}

const useStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    overflowX: 'auto',
  },

  tableCell: {
    padding: `0 ${theme.spacing(2)}`,
  },
}))

const ConfirmCheckoutProducts: React.FC<ConfirmCheckoutProductsProps> = ({
  isDataLoading,
  isCartUpdating,
  products,
  onUpdateProduct,
  onDeleteProduct,
  handleCartResponse,
}) => {
  const noProductsInCart = products?.lineItems.length === 0
  const { t } = useCustomTranslation()
  useQuantityTypeChangeModal(products)
  const { classes } = useStyles()

  if (noProductsInCart) {
    return (
      <Grid item xs={12} md={12}>
        <Typography sx={{ my: 4 }} align="center">
          {t('shop.confirm-checkout.no-items-available')}
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid item xs={12} className={classes.container}>
      <Table size="medium" sx={{ overflowX: 'auto' }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Typography>{t('shop.confirm-checkout.product')}</Typography>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Typography>{t('shop.confirm-checkout.crowd')}</Typography>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Typography>{t('shop.confirm-checkout.price-per-product')}</Typography>
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Typography>{t('shop.confirm-checkout.total')}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isDataLoading &&
            products?.lineItems.map(product => {
              return (
                <ConfirmCheckoutSingleProduct
                  key={product.id}
                  isLoading={isCartUpdating}
                  product={product}
                  onUpdateProduct={onUpdateProduct}
                  onDeleteProduct={onDeleteProduct}
                  handleCartResponse={handleCartResponse}
                />
              )
            })}
        </TableBody>
      </Table>
    </Grid>
  )
}

export default ConfirmCheckoutProducts
